import doelgerTheme from 'typography-theme-doelger'

import { TypographyOptions } from './types'

export const typography: TypographyOptions = {
  ...doelgerTheme,
  baseFontSize: '16px',
}
